import { forwardRef } from "react";
import { useId } from "react";
function SvgRawRewardIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 36 36"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill={`url(#RawRewardIcon_svg__a${toAppend})`}
        d="M1.071 5.512a4.44 4.44 0 0 1 4.44-4.44h16.097c7.357 0 13.32 5.963 13.32 13.32v16.096a4.44 4.44 0 0 1-4.44 4.44H5.512a4.44 4.44 0 0 1-4.44-4.44V5.512Z"
      />
      <path
        fill="#AF761E"
        d="M4.68 6.9A2.22 2.22 0 0 1 6.9 4.68h14.43c5.518 0 9.99 4.472 9.99 9.99v13.876a2.22 2.22 0 0 1-2.22 2.22H6.9a2.22 2.22 0 0 1-2.22-2.22V6.899Z"
      />
      <path
        fill="#FDAD2F"
        d="M6.066 9.12a2.22 2.22 0 0 1 2.22-2.221h12.766a8.88 8.88 0 0 1 8.88 8.88v12.766a2.22 2.22 0 0 1-2.22 2.22H8.288a2.22 2.22 0 0 1-2.22-2.22V9.12Z"
      />
      <path
        fill="#AF761E"
        d="M26.386 27.646H18.7V11.044l.922-.922 2.94.922a3.831 3.831 0 0 1 3.824 3.823l.922 11.857-.922.922ZM16.548 27.646H8.862V11.044l.922-.922 6.764.922.922 15.68-.922.922Z"
      />
      <path
        fill={`url(#RawRewardIcon_svg__b${toAppend})`}
        d="M27.308 26.724h-7.686V10.122h3.861a3.831 3.831 0 0 1 3.825 3.823v12.779Z"
      />
      <path
        fill={`url(#RawRewardIcon_svg__c${toAppend})`}
        d="M17.47 26.724H9.784V10.122h7.686v16.602Z"
      />
      <defs>
        <linearGradient
          id={`RawRewardIcon_svg__a${toAppend}`}
          x1={6.076}
          x2={25.36}
          y1={1.071}
          y2={38.461}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDA009" />
          <stop offset={1} stopColor="#FFDD70" />
        </linearGradient>
        <linearGradient
          id={`RawRewardIcon_svg__b${toAppend}`}
          x1={23.465}
          x2={23.465}
          y1={10.122}
          y2={26.724}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC566" />
          <stop offset={1} stopColor="#FFE37E" />
        </linearGradient>
        <linearGradient
          id={`RawRewardIcon_svg__c${toAppend}`}
          x1={13.627}
          x2={13.627}
          y1={10.122}
          y2={26.724}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC566" />
          <stop offset={1} stopColor="#FFE37E" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawRewardIcon);
export default ForwardRef;
